import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import React from 'react';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  Field, // itemWrapperErrorDisplayAdaptor
} from 'src/components/RcForm';
import {
  Policy,
  items,
  linkTo,
  policy,
  title,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/constant';
//import css from './css.module.less';
import {
  //   Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { sectionProps } from 'src/tools/constant';
//import { get } from 'lodash';
import { LinkModuleType } from '@/src/types/common/linkType';
import arrayMove from 'array-move';
import { useParams } from 'react-router-dom';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { useI18n } from 'src/hooks/useRouterChange';
import InputSelectAndDelete from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/Policy/InputAndLink';
import {
  checkEachPolicy,
  checkPolicy,
  generateDefaultLinkTo,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/validator';
import { randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useSelector } from 'react-redux';

const { checkLink, checkTitle } = checkEachPolicy();

const P = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _params: {
    saleChannelUuid: string;

    contentUuid: string;
  } = useParams();
  const { saleChannelUuid, contentUuid } = _params;
  const { breakpoint, disabled } = props;
  const linkSet = {
    scopeVariables: {
      SalesChannelContent: contentUuid,
    },
    linkTypeFilter: [LinkModuleType.None, LinkModuleType.LegalPage],
  };
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());

  return (
    <Wrapper id={Policy} breakpoint={breakpoint}>
      <BlockTitle
        id={Policy}
        title={getI18n('general.hOCTitle.policy')}
        breakpoint={breakpoint}
        onReset={
          () => {
            return;
          } // handleOnSectionReset(item?.fields, breakpoint)
        }
        onCopy={
          () => {
            return;
          } // handleOnSectionCopy(item?.fields, breakpoint)}
        }
        headerErrorDependencies={[[policy, items]]}
        validator={(data) => {
          return checkPolicy(data);
        }}
      />

      <Section
        {...{
          ...sectionProps,
          style: { paddingTop: 0, paddingLeft: 0, paddingRight: 0 },
        }}>
        <Field
          name={[policy, items]}
          initialValue={[
            {
              draggableId: `policy_${randomNumber()}`,
              title: `${getI18n('general.hOCTitle.policy')} 1`,
              linkTo: generateDefaultLinkTo(saleChannelUuid),
            },
          ]}>
          {(props, m) => {
            // const errors = get(m, 'errors') || [];
            const { value, onChange } = props;
            const handleOnSort = (obj) => {
              const { data } = obj;
              const { newIndex, oldIndex } = data || {};
              const nValue = arrayMove(value || [], oldIndex, newIndex);
              onChange(nValue);
            };

            const handleOnAdd = (node) => {
              const policyDraggableId = `policy_${randomNumber()}`;
              const nD = {
                draggableId: policyDraggableId,
                title: `${getI18n('general.hOCTitle.policy')} ${
                  (value || []).length + 1
                }`,
                linkTo: generateDefaultLinkTo(saleChannelUuid),
              };
              onChange([...(value || []), nD]);
            };

            const handleOnDelete = (index) => {
              const v = (value || []).filter((_, i) => {
                return i !== index;
              });
              onChange(v);
            };

            const childGenerate = (data, index) => {
              // const { title, linkTo, draggableId = '' } = data;

              return (
                <InputSelectAndDelete
                  disabled={disabled}
                  inputTitle={getI18n('salesChannelContent.index.policyTitle')}
                  linkSet={linkSet}
                  textName={[policy, items, index, title]}
                  linkName={[policy, items, index, linkTo]}
                  textMaxLength={100}
                  onDelete={() => {
                    handleOnDelete(index);
                  }}
                  hideDelete={(value || []).length < 2 || disabled}
                  linkValidator={checkLink}
                  textValidator={checkTitle}
                />
              );
            };
            // const eP = antdErrorDisplayAdaptor(m);
            return (
              <DragNDropColumns
                disabled={disabled}
                //dragHide={!isPrimary}
                hideTitle
                childGenerate={childGenerate}
                data={value || []}
                droppableId={'Policy'}
                onSort={handleOnSort}
                hideAdd={disabled || !isOnPrimaryLanguage}
                hideAddText={disabled || !isOnPrimaryLanguage}
                onAdd={handleOnAdd}
                addText={`+ ${getI18n(
                  'salesChannelContent.index.addNewPolicy',
                )}`}
              />
            );
          }}
        </Field>
      </Section>
    </Wrapper>
  );
};
export default P;
